// extracted by mini-css-extract-plugin
module.exports = {"document":"motion-document_document__NHw_0"};